"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFullscreen = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function useFullscreen() {
    var _a = react_1.default.useState(false), isFullscreenActive = _a[0], setFullscreenActive = _a[1];
    var toggleFullscreen = function () {
        if (isFullscreenActive) {
            closeFullscreen();
        }
        else {
            openFullscreen();
        }
    };
    var openFullscreen = function () {
        if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen();
        }
        else if (document.documentElement.webkitRequestFullscreen) {
            /* Safari */
            document.documentElement.webkitRequestFullscreen();
        }
        else if (document.documentElement.msRequestFullscreen) {
            /* IE11 */
            document.documentElement.msRequestFullscreen();
        }
        setFullscreenActive(true);
    };
    var closeFullscreen = function () {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        }
        else if (document.webkitExitFullscreen) {
            /* Safari */
            document.webkitExitFullscreen();
        }
        else if (document.msExitFullscreen) {
            /* IE11 */
            document.msExitFullscreen();
        }
        setFullscreenActive(false);
    };
    return { openFullscreen: openFullscreen, closeFullscreen: closeFullscreen, toggleFullscreen: toggleFullscreen, isFullscreenActive: isFullscreenActive };
}
exports.useFullscreen = useFullscreen;
